<div class="unreachable-map-modal">
    <mat-icon class="close-icon" (click)="onClose()">close</mat-icon>
    <h2 mat-dialog-title class="map-title">Map View</h2>
    <div mat-dialog-content>
        <div #mapContainer class="map-container"></div>
    </div>
</div>
